import { render } from "./ViewBonCommandeFournisseur.vue?vue&type=template&id=058dace2&scoped=true&ts=true"
import script from "./ViewBonCommandeFournisseur.vue?vue&type=script&lang=ts"
export * from "./ViewBonCommandeFournisseur.vue?vue&type=script&lang=ts"

import "./ViewBonCommandeFournisseur.vue?vue&type=style&index=0&id=058dace2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-058dace2"]])

export default __exports__